import initAvailabilityOption from 'owa-calendar-availability-option/lib/orchestration/initAvailabilityOption';
import { trace } from 'owa-trace';

export default async function initializeAvailabilitySubCategory(): Promise<boolean> {
    try {
        await initAvailabilityOption();
        return true;
    } catch (e) {
        trace.warn(e.message || 'initializeAvailabilitySubCategory failed');
        return false;
    }
}
